<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import ComboBox from 'dashboard/components-next/combobox/ComboBox.vue';

const emit = defineEmits(['submit']);

const { t } = useI18n();

const dialogRef = ref(null);
const selectedLabel = ref(null);
const conversationContext = ref(null);

const labels = useMapGetter('labels/getLabels');

const labelOptions = computed(() =>
  (labels.value || []).map(label => ({
    value: label.title,
    label: label.title,
  }))
);

const isFormComplete = computed(() => !!selectedLabel.value);

const close = () => {
  dialogRef.value?.close();
  conversationContext.value = null;
  selectedLabel.value = null;
};

const open = (context = null) => {
  selectedLabel.value = null;
  conversationContext.value = context;
  dialogRef.value?.open();
};

const handleConfirm = () => {
  if (!isFormComplete.value) return;

  emit('submit', {
    label: selectedLabel.value,
    context: conversationContext.value,
  });
  close();
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="lg"
    :title="t('CONVERSATION_WORKFLOW.RESOLUTION_LABEL.MODAL.TITLE')"
    :description="t('CONVERSATION_WORKFLOW.RESOLUTION_LABEL.MODAL.DESCRIPTION')"
    :confirm-button-label="
      t('CONVERSATION_WORKFLOW.RESOLUTION_LABEL.MODAL.ACTIONS.RESOLVE')
    "
    :cancel-button-label="
      t('CONVERSATION_WORKFLOW.RESOLUTION_LABEL.MODAL.ACTIONS.CANCEL')
    "
    :disable-confirm-button="!isFormComplete"
    @confirm="handleConfirm"
  >
    <div class="flex flex-col gap-2">
      <label class="mb-0.5 text-sm font-medium text-n-slate-12">
        {{ t('CONVERSATION_WORKFLOW.RESOLUTION_LABEL.MODAL.LABEL_FIELD') }}
      </label>
      <ComboBox
        v-model="selectedLabel"
        :options="labelOptions"
        :placeholder="
          t('CONVERSATION_WORKFLOW.RESOLUTION_LABEL.MODAL.PLACEHOLDER')
        "
        class="w-full"
      />
    </div>
  </Dialog>
</template>
